import { render, staticRenderFns } from "./ModalCreatePerson.vue?vue&type=template&id=664d0bbe&scoped=true"
import script from "./ModalCreatePerson.vue?vue&type=script&lang=js"
export * from "./ModalCreatePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d0bbe",
  null
  
)

export default component.exports